/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import DonePageMediaDesktop from "assets/Screens/done-desktop.png";
import DonePageMediaMobile from "assets/Screens/done-mobile.png";
import { Button, Heading, Stack, Text } from "components";
import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";
import { useTranslation } from "react-i18next";
import { unsubscribe } from "lib/userApi";
import { useEffect } from "react";
import useLocalStorage from "utils/useLocalStorage";
import { ScreenPage } from "templates";
import { useOrgData } from "state/OrgDataContext";
import useEventRouting from "hooks/useEventRouting";

const UnsubscribePage = () => {
  const { t } = useTranslation();
  const { dataContent: EVENT_CONTENT } = useOrgData();
  const [userId] = useLocalStorage(LOCAL_STORAGE_KEYS.id, null);
  const { eventId } = useEventRouting();

  useEffect(() => {
    unsubscribe(userId, eventId);
  }, []);

  return (
    <ScreenPage
      desktopBG={DonePageMediaDesktop}
      mobileBG={DonePageMediaMobile}
      showNotification={false}
    >
      <Stack component="article" className="h-full text-center">
        <div className="flex items-center justify-center gap-x-3">
          <Heading as="h2" className="font-bold mb-2 !text-3xl md:!text-4xl">
            {t("unsubscribePage.thankYou")}
          </Heading>
        </div>
        <Text className="text-font-primary text-sm md:text-base">
          {t("unsubscribePage.unsubscribedMSG")}
        </Text>
        <div className="mt-12">
          <Text className="text-font-primary text-sm md:text-base">
            {t("unsubscribePage.emailMSG")}
            <Button
              as="externalLink"
              href={"mailto:info@theunityapp.ph"}
              variant="ghost"
              className="!inline"
            >
              <span className="underline">
                {EVENT_CONTENT.unsubscribePage.emailURL}
              </span>
            </Button>
            {t("unsubscribePage.forAnyQuestions")}
          </Text>
        </div>
      </Stack>
    </ScreenPage>
  );
};
export default UnsubscribePage;
